module.exports = __webpack_public_path__ + "static/portfolio3-93251d2da0e224232abf7a6ef96df45a.jpg";